<template>
    <div>
        <section class="error-404 error-mobile ">
            <figure class="text-center">
                <img src="https://images.livspace-cdn.com/plain/https://d3gq2merok8n5r.cloudfront.net/./error-page-mobile-1649312597-LVNYN.png" alt="404 Error Image" class="img-responsive">
            </figure>
            <header class="text-center error-head">
                <h1>Whoops!<br>Wrong address</h1>
                <p class="center-block">We are sorry but the page you requested is unavailable</p>
            </header>
        </section>
    </div>
</template>

<script>
    export default {

        mounted() {
            this.$router.push('/')
        }
    }
</script>
